import { ABOUT } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";

export const Studio = () => (
  <section
    id="about"
    data-testid="studio-section"
    className="relative bg-obsidian py-20 md:py-28"
  >
    <div className="mx-auto max-w-shell px-6 md:px-10">
      <div className="grid md:grid-cols-12 gap-12 md:gap-16">
        <div className="md:col-span-5">
          <Reveal>
            <div className="label-xs text-champagne">{ABOUT.eyebrow}</div>
            <h2 className="mt-6 font-display font-normal text-ivory leading-[1.06] tracking-[-0.015em] text-[clamp(1.9rem,3.6vw,3rem)]">
              {ABOUT.title}
            </h2>
          </Reveal>
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <Reveal delay={0.1}>
            <div className="space-y-6">
              {ABOUT.body.map((p, i) => (
                <p
                  key={i}
                  className={
                    i === 0
                      ? "text-lg md:text-xl font-light leading-relaxed text-ivory"
                      : "text-[0.95rem] font-light leading-relaxed text-ivory/60"
                  }
                >
                  {p}
                </p>
              ))}
            </div>

            <dl className="mt-12 border-t border-ivory/15">
              {ABOUT.points.map(([k, v]) => (
                <div
                  key={k}
                  className="flex items-baseline justify-between gap-8 py-4 border-b border-ivory/15"
                >
                  <dt className="label-xs text-mist shrink-0">{k}</dt>
                  <dd className="text-sm text-ivory/85 text-right">{v}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Studio;
